import React, { Component } from 'react';
import Status from './Components/Status';
// import logo from './logo.svg';
import './App.css';
import axios from 'axios';
import {PulseLoader} from 'react-spinners';
import Countdown from 'react-countdown-moment'
import moment from 'moment'
import ReactCountdownClock from 'react-countdown-clock';
import ReactDOM from 'react-dom'

class App extends Component {
  constructor(props) {
    super(props);

    this.checkSpot = this.checkSpot.bind(this);
    this.powerOn = this.powerOn.bind(this);
    this.powerOff = this.powerOff.bind(this);
    this.checkServers = this.checkServers.bind(this);
    this.allStatus = this.allStatus.bind(this);
    this.endTimer = this.endTimer.bind(this);
    this.testFunc = this.testFunc.bind(this);

    this.state = {
      overall: "checking",
      ag: "N/A",
      tref: "N/A",
      loading: true,
      timer: false
    };

    this.allStatus();
  }

  checkSpot() {
    this.agStatus();
    this.trefStatus();
  }

  checkServers() {
    this.setState({
      overall: "checking",
      ag: "N/A",
      tref: "N/A",
      loading: true
    });
    this.allStatus();
  }

  allStatus() {
    axios.get('https://api.mcsrvstat.us/1/ag.mc.trefsoftware.com')
      .then(response => {
        console.log(response);
        if(response.data.offline === true) {
        } else {
          this.setState({
            ag: response.data.players.online + "/" + response.data.players.max
          })
        }
        axios.get('https://api.mcsrvstat.us/1/tref.mc.trefsoftware.com')
          .then(response => {
            console.log(response);
            if(response.data.offline === true) {
              this.setState({
                overall: "offline"
              });
            } else {
              this.setState({
                overall: "online",
                tref: response.data.players.online + "/" + response.data.players.max
              })
            }
            this.setState({
              loading: false
            });
          });
      });
  }

  agStatus() {
    axios.get('https://mcapi.us/server/status?ip=ag.mc.trefsoftware.com')
      .then(response => {
        if(response.data.online === false) {
          this.setState({
            overall: "offline"
          });
        } else {
          this.setState({
            overall: "online",
            ag: response.data.players.now + "/" + response.data.players.max
          })
        }
        this.setState({
          loading: false
        });
      });
  }

  trefStatus() {
    axios.get('https://mcapi.us/server/status?ip=tref.mc.trefsoftware.com')
      .then(response => {

        if(response.data.online === false) {
          this.setState({
            overall: "offline"
          });
        } else {
          this.setState({
            overall: "online",
            tref: response.data.players.now + "/" + response.data.players.max
          })
        }
      });
  }

  powerOn() {
    this.setState({
      loading: true
    });
    axios.post(' https://vb17r9cfui.execute-api.us-east-2.amazonaws.com/prod/mc')
      .then(response => {
        console.log(response);
        this.setState({
          loading: false,
          timer: true,
          overall: "checking"
        });
        ReactDOM.render(
          <ReactCountdownClock seconds={120}
                               color="#000"
                               alpha={0.9}
                               size={50}
                               onComplete={this.endTimer} />,
          document.getElementById('tut')
        );
      });
  }

  endTimer() {
    this.setState({
      timer: false
    });
    this.checkServers();
  }

  powerOff() {
    this.setState({
      loading: true
    });
    axios.delete(' https://vb17r9cfui.execute-api.us-east-2.amazonaws.com/prod/mc')
      .then(response => {
        console.log(response);
        var test = this;
        setTimeout(function() {
          test.testFunc();
        }, 10000);
      });
  }

  testFunc() {
    this.setState({
      loading: false
    });
    this.checkServers();
  }

  render() {
    return (
      <div className="App">
        <header className="App-header">
          {/*<img src={logo} className="App-logo" alt="logo" />*/}
          <h1 className="App-title">TrefSoftware Minecraft</h1>
        </header>
        {/*<p className="App-intro">
          To get started, edit <code>src/App.js</code> and save to reload.
        </p>*/}
        <br/>
        {this.state.timer ? <div className={'test'} id={"tut"}>
        </div> : null}
        <div>
          <div>
            <PulseLoader loading={this.state.loading}/>
          </div>
          <div className={this.state.timer ? 'gap' : ""}>
            <h2>The server is: <span className={this.state.overall}>{this.state.overall}</span></h2>
          </div>
          <p>AG Server: <span>{this.state.ag}</span></p>
          <p>Tref Server: <span>{this.state.tref}</span></p>
        </div>
        <div className="button_container">
          <button className='button' onClick={this.checkServers}>Check Servers</button>
        </div>
        <br />
        <div className="button_container">
          <button className='button' onClick={this.powerOn} disabled={this.state.overall === "online" || this.state.overall === "checking" }>Power On</button>
        </div>
        <br />
        <div className="button_container">
          <button className='button button2' onClick={this.powerOff} disabled={this.state.overall === "offline" || this.state.overall === "checking" } >Power Off</button>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js